export default __webpack_public_path__ + "static/media/gta.a6c38a2b.webp";